/* @flow */
import * as React from 'react';
import { IndexRoute, Route, IndexRedirect } from 'react-router';

import { AdminAutoMessages } from 'admin/components/AdminAutoMessages';
import { AdminAutoMessageDetail } from 'admin/components/AdminAutoMessageDetail';
import { AdminUploadedFiles } from 'admin/components/AdminUploadedFiles';
import { AdminAutoMessageSftpCredentials } from 'admin/components/AdminAutoMessageSftpCredentials';
import AdminAdminsRedirect from 'admin/components/AdminAdminsRedirect.jsx';
import AdminBillingOverview from 'admin/components/AdminBillingOverview.jsx';
import AdminClassesTable from 'admin/components/AdminClassesTable.jsx';
import AdminHomeView from 'admin/components/AdminHomeView.jsx';
import AdminIntegratedToolsView from 'admin/components/AdminIntegratedToolsView.jsx';
import AdminOrgAdminsView from 'admin/components/AdminOrgAdminsView.jsx';
import AdminSchoolAdminsView from 'admin/components/AdminSchoolAdminsView.jsx';
import AdminSchools from 'admin/components/AdminSchools.jsx';
import AdminSettingsLayout from 'admin/components/AdminSettingsLayout.jsx';
import AdminSisDashboardContainer from 'admin/containers/AdminSisDashboardContainer.jsx';
import AdminStatisticsView from 'admin/components/AdminStatisticsView.jsx';
import AnnouncementStreamDefaultView from 'chat/components/AnnouncementStream/components/AnnouncementStreamDefaultView.jsx';
import AnnouncementStreamView from 'chat/components/AnnouncementStream/components/AnnouncementStreamView.jsx';
import BootstrapHandler from 'groups/components/BootstrapHandler.jsx';
import ChatDefaultView from 'chat/components/ChatDefaultView.jsx';
import ConversationView from 'chat/components/ConversationView.jsx';
import CreateGroupHandler from 'groups/components/CreateGroupHandler.jsx';
import FilesContainer from 'files/containers/FilesContainer.jsx';
import GroupContainer from 'groups/containers/GroupContainer.jsx';
import GroupInviteHandler from 'groups/components/GroupInviteHandler.jsx';
import GroupMessagesContainer from 'groups/containers/GroupMessagesContainer.jsx';
import GroupPeopleTable from 'groups/components/GroupPeopleTable.jsx';
import GroupSettingsHandler from 'groups/components/GroupSettingsHandler.jsx';
import GroupsIndexHandler from 'groups/components/GroupsIndexHandler.jsx';
import GroupsView from 'groups/components/GroupsView.jsx';
import GroupView from 'groups/components/GroupView.jsx';
import GroupViewIndex from 'groups/components/GroupViewIndex.jsx';
import JoinGroupHandler from 'groups/components/JoinGroupHandler.jsx';
import PhoneCallsTab from 'phoneCalls/components/PhoneCallsTab.jsx';
import RequireFeatures from 'lib/RequireFeatures';

export default (
  <Route path="/classes(/)" component={GroupsView} onEnter={GroupsView.onEnter}>
    <IndexRoute component={GroupsIndexHandler} />
    <Route path="start" component={BootstrapHandler} />
    <Route path="join" component={JoinGroupHandler} />
    <Route path="new" component={CreateGroupHandler} />
    <Route path=":groupCode" component={GroupContainer}>
      <IndexRoute component={GroupViewIndex} />
      <Route components={GroupView}>
        <Route path="messages" component={GroupMessagesContainer}>
          <Route
            path="new(/:memberId)"
            component={ConversationView}
            onEnter={ConversationView.onEnter}
            onLeave={ConversationView.onLeave}
          />
          <Route path="stream(/)">
            <Route path=":uuid" component={AnnouncementStreamView} />
            <IndexRoute
              component={AnnouncementStreamDefaultView}
              onEnter={AnnouncementStreamDefaultView.onEnter}
            />
          </Route>
          <Route path=":chatId" component={ConversationView} onEnter={ConversationView.onEnter} />
          <IndexRoute component={ChatDefaultView} onEnter={ChatDefaultView.onEnter} />
        </Route>
        <Route path="invite" component={GroupInviteHandler} />
        <Route path="settings" component={GroupSettingsHandler} />
        <Route path="files" component={FilesContainer} />
        <Route path="people" component={GroupPeopleTable} />
        <Route path="calls" component={PhoneCallsTab} />
        <Route path="classes" component={AdminClassesTable} />
        <Route path="home" component={AdminHomeView} />
        <Route path="statistics" component={AdminStatisticsView} />
        <Route path="schools" component={AdminSchools} />
        <Route path="settings" component={AdminSettingsLayout}>
          <IndexRedirect to="settings/organization" />
          <Route path="organization">
            <IndexRedirect to="administrators" />
            <Route path="administrators">
              <IndexRoute component={AdminAdminsRedirect} />
              <Route path="district" component={AdminOrgAdminsView} />
              <Route path="school" component={AdminSchoolAdminsView} />
              <Route path="*" component={AdminAdminsRedirect} />
            </Route>
            <Route path="billing" component={AdminBillingOverview} />
            <Route path="sis_sync" component={AdminSisDashboardContainer} />
            <Route path="integrated_tools" component={AdminIntegratedToolsView} />
            <Route
              onEnter={RequireFeatures(
                ['2018.nov.web.auto_messaging'],
                (nextState, replaceWith) => {
                  replaceWith('/classes');
                }
              )}>
              <Route path="auto_messages">
                <IndexRoute component={AdminAutoMessages} />
                <Route path=":uuid" component={AdminAutoMessageDetail} />
              </Route>
              <Route path="uploaded_files" component={AdminUploadedFiles} />
              <Route path="sftp_credentials" component={AdminAutoMessageSftpCredentials} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>
  </Route>
);
